import { DropdownMenuItem } from '@/shared/components';
import { cn } from '@/shared/utils';
import { ActionMenuItemContent } from './ActionMenuItemContent';
import type { ComponentType, ReactNode, SVGProps } from 'react';

interface Props {
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
  labelIcon?: ReactNode;
  children?: ReactNode;
  onClick: () => void;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  childrenClassName?: string;
}

export const ActionMenuItem = ({
  icon: Icon,
  label,
  labelIcon,
  children,
  onClick,
  className,
  iconClassName,
  labelClassName,
  childrenClassName,
}: Props) => (
  <DropdownMenuItem
    showOptionCheckmark={false}
    className={cn(
      'h-[4.8rem] w-full rounded-[1.2rem] cursor-pointer',
      className
    )}
    onClick={e => {
      e.stopPropagation();
      onClick();
    }}>
    <ActionMenuItemContent
      className={childrenClassName}
      iconClassName={iconClassName}
      labelClassName={labelClassName}
      icon={Icon}
      label={label}
      labelIcon={labelIcon}>
      {children}
    </ActionMenuItemContent>
  </DropdownMenuItem>
);
